/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

import { FancyFirebaseSplitDataList } from '../generics/FancyFirebaseSplitDataList';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { RoleFields, Role } from '@touchplan/common';
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { IFancyIdJoin } from '../base/FancyIdJoin';

export class RoleList
	extends FancyFirebaseSplitDataList<RoleFields, DefaultSplitDataRenderType, Role>
	implements IFancyIdJoin
{
	constructor(angularLand: AngularLandConnection, path: RefOrObservable, fancyJoins?: any) {
		//fix any's
		super(angularLand, path, fancyJoins);
	}

	public $$added(action: AngularFireAction<DatabaseSnapshot<any>>) {
		const role = new Role(action.payload.key);
		role.databaseUpdate(action.payload.val());
		return role;
	}
	public $$updated(child: Role, action: AngularFireAction<DatabaseSnapshot<any>>) {
		super.$$updated(child, action);
	}

	//put in interface so you can explicitly say you're doing this
	public applyJoinData(baseKey: string, child: Role, otherChild: any) {
		switch (baseKey) {
			case 'roleColor':
				child.view.color = otherChild ? otherChild.color || otherChild.view.color : null;
				break;
			default:
				break;
		}
	}
	public getDataForKey(baseKey: string, child: Role) {
		return child.view[baseKey];
	}
}
